<template>
  <div
    v-drag
    class="configure-tree position-absolute p-10"
    :class="setSemitransparent ? 'semitransparent' : ''"
  >
    <div class="tree-header p-b-10 w-100 d-flex flex-row-between flex-align-center">
      <span>组态管理</span>
      <i @click="closeDialog" class="cur_pointer iconfont icon-close"></i>
    </div>
    <div class="tree-box">
      <el-tree
        class="m-t-10 h-100 dialog-body"
        highlight-current
        :data="treeList"
        @node-click="checkConfigure"
        :props="defaultTreeProps"
        check-strictly
        ref="treeList"
        node-key="id"
      >
        <span
          slot-scope="{ node }"
          class="p-l-10 el-tree-node__label w-100 text-overflow flex-row-between"
        >
          <el-tooltip :content="node.label" :open-delay="1000" placement="top">
            <span class="ell tl tree-label">{{ node.label }}</span>
          </el-tooltip>
        </span>
      </el-tree>
    </div>
  </div>
</template>
<script>
import ConfigureManage from '@/services/configureManage'

export default {
  props: ['setSemitransparent'],
  data() {
    return {
      defaultTreeProps: {
        // 目录树配置选项
        children: 'children',
        label: 'name',
      },
      treeList: [],
      configureDetailList: [], // 组态对象列表
      configureId: null, // 组态id
    }
  },
  created() {
    this.getConfigureList()
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  methods: {
    // 获取组态列表
    async getConfigureList() {
      // 获取组态列表
      const dataParams = {
        site_id: this.currentProject.id,
        pageno: 1,
        pagesize: 9999,
        orderby: 'name',
        isasc: true,
        relation_model_document_id: this.$route.query.documentId || '',
      }
      const res = await ConfigureManage.getConfigureList(dataParams)
      if (res && res.code === 0 && res.data) {
        this.treeList = res.data
      }
    },
    // 选中组态
    async checkConfigure(data) {
      if (this.configureId === data.id) {
        return
      }
      this.initModelVisible()
      this.configureDetailList = []
      const dataParams = {
        pageno: 1,
        pagesize: 999,
        three_dimensional_configure_id: data.id,
      }
      const res = await ConfigureManage.getConfigureDetailList(dataParams)
      if (res && res.code === 0 && res.data) {
        _.forEach(res.data, (item) => {
          this.configureDetailList.push({
            id: item.id,
            modelCode: item.modelCode,
            modelName: item.modelName,
          })
        })

        if (!_.isEmpty(this.configureDetailList)) {
          const modelCodes = _.map(this.configureDetailList, 'modelCode')
          console.log(modelCodes)
          const itemInfo = await PlayerUtils.call(window.player.Native.ModelTree.getRootItems)
          const itemTrees = _.map(itemInfo, 'item')
          window.player.Native.ModelTree.setItemVisible(itemTrees, false)
          window.player.Native.ModelTree.setItemVisible(modelCodes, true)
        }
      }
      this.configureId = data.id
    },
    // 关闭弹框
    async closeDialog() {
      this.initModelVisible()
      this.$emit('closeComponents')
    },
    // 初始化模型显示
    async initModelVisible() {
      const itemInfo = await PlayerUtils.call(window.player.Native.ModelTree.getRootItems)
      const itemTrees = _.map(itemInfo, 'item')
      window.player.Native.ModelTree.setItemVisible(itemTrees, true)
    },
  },
}
</script>
<style lang="scss" scoped>

.configure-tree {
  height: 390px;
  width: 330px;
  left: 8px;
  top: 46px;
  background-color: rgba(255, 255, 255, 0.76);
  border-radius: 4px;
  z-index: 99;
  .tree-header {
    border-bottom: 1px solid #dcdfe6;
  }
  .tree-box {
    height: calc(100% - 45px);
  }
}

</style>
